import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=8510e82e&scoped=true&"
import script from "./auth.vue?vue&type=script&lang=js&"
export * from "./auth.vue?vue&type=script&lang=js&"
import style0 from "./auth.vue?vue&type=style&index=0&lang=css&"
import style1 from "./auth.vue?vue&type=style&index=1&id=8510e82e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8510e82e",
  null
  
)

export default component.exports